import { useMemo } from 'react';
import { useDynamicList, notEmptyString } from '@shopify/react-form';
import gettext from '@sdk/lang/gettext';
import { TimesheetEntry } from '@sdk/timesheets/types/TimesheetEntry';

import {
  isValidTimeValue,
  breaksValidator,
  clockOutValidator,
} from '@web/timesheets/CreateTimesheetModal/utils/validation';
import { getTimeClockEntriesForDynamicList } from '@web/timesheets/EditTimesheetModal/editTimesheetModal.utils';
import { getEmptyTimeClockEntry } from '@web/timesheets/CreateTimesheetModal/utils/timeClockUtils';
import { validateIfNotDeleted } from '@web/forms/utils/validateIfNotDeleted';

/**
 * This hook creates Time Clock entries section - dynamic list of entries, that are clock in and clock out times.
 */
const useTimeClockSection = (timesheetEntries: TimesheetEntry[]) => {
  const timeClockEntries = useMemo(
    () => getTimeClockEntriesForDynamicList(timesheetEntries),
    [timesheetEntries]
  );

  return useDynamicList(
    {
      list: timeClockEntries,
      validates: {
        clockIn: [
          validateIfNotDeleted(notEmptyString(gettext('Clock in time is missing'))),
          validateIfNotDeleted(isValidTimeValue),
        ],
        clockOut: clockOutValidator,
        breaks: breaksValidator,
      },
    },
    getEmptyTimeClockEntry
  );
};

export default useTimeClockSection;
